/**
 * Modal wrapper component of Material UI Dialog
 */
import React from "react"
import PropTypes from "prop-types"
import {
  ModalTitle,
  ModalSubTitle,
  ModalContent,
  IconCont,
  StyledDialog,
  StyledDialogOverflow,
} from "./styles"
import Icon from "components/Icon"

export const Modal = ({
  title,
  subtitle,
  content,
  align,
  open,
  icon,
  width,
  overflowcontent,
  ...other
}) => {
  // NOTE: Something slightly odd here. The "overflowcontent" prop is in case we want a select box to overflow past the
  // boundaries of the modal. The only place so far this is the case is "Move to folder" modal in the candidates section.
  // Since we can't pass props to the withStyles function I've had to define two dialogs and conditionally return the right
  // one depending on the prop. Bit clunky but works. - Richard

  return overflowcontent ? (
    <StyledDialogOverflow open={open} {...other} width={width}>
      <ModalTitle
        align={align}
        variant={"sectionTitle"}
        as={"h1"}
        weight={"light"}
      >
        {icon ? (
          <IconCont>
            <Icon variant={icon} />
          </IconCont>
        ) : null}
        {title}
      </ModalTitle>
      {subtitle ? (
        <ModalSubTitle
          align={align}
          variant={"text"}
          as={"div"}
          weight={"bold"}
        >
          {subtitle}
        </ModalSubTitle>
      ) : null}
      <ModalContent align={align}>{other.children}</ModalContent>
    </StyledDialogOverflow>
  ) : (
    <StyledDialog open={open} {...other} width={width}>
      <ModalTitle
        align={align}
        variant={"sectionTitle"}
        as={"h1"}
        weight={"light"}
      >
        {icon ? (
          <IconCont>
            <Icon variant={icon} />
          </IconCont>
        ) : null}
        {title}
      </ModalTitle>
      {subtitle ? (
        <ModalSubTitle
          align={align}
          variant={"text"}
          as={"div"}
          weight={"bold"}
        >
          {subtitle}
        </ModalSubTitle>
      ) : null}
      <ModalContent align={align}>{other.children}</ModalContent>
    </StyledDialog>
  )
}
Modal.defaultProps = {
  open: false,
}

Modal.propTypes = {
  width: PropTypes.string,
  title: PropTypes.string,
  align: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
  open: PropTypes.bool,
}

export default Modal
